import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

import { MIN_HEADER_HEIGHT } from "../../../../constants";

const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  ctaButtonContainer: {
    alignSelf: "center"
  },
  infoContainer: {
    display: "flex",
    flexGrow: 1,
    flexWrap: "nowrap"
  },
  logoRating: {
    marginRight: unit * 3,
    textAlign: "center"
  },
  mainContainer: {
    display: "flex",
    margin: "auto",
    maxWidth: "968px",
    minHeight: `${MIN_HEADER_HEIGHT}px`,
    padding: unit * 3
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
